import './AppCurtain.less';

import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

const AppCurtain: React.FC = () => {
  const loading = useSelector((state: RootState) => state.global.loading);
  if (!loading) return null;
  return (
    <div className="loading-overlay">
      <Spin size="large" />
    </div>
  );
};

export default AppCurtain;
